import { apiPath, buildApiUrl } from '../_utils/api-version'
import { IStaticPage } from '../_types'
import { request } from './http-client'

export const staticPageService = {
  getAll: (shipper_id?: string, useDynamicLanguage = false) =>
    request.get<{ static_pages: IStaticPage[] }>(
      apiPath('static-page', useDynamicLanguage),
      {
        headers: {
          Shipper: shipper_id,
        },
      }
    ),
  getList: (params: any, useDynamicLanguage = false) =>
    request.get<{ data: IStaticPage[]; count: number }>(
      apiPath('static-page', useDynamicLanguage),
      {
        params,
      }
    ),
  getById: (id: string, useDynamicLanguage = false) =>
    request.get<any>(buildApiUrl('static-page', useDynamicLanguage, id)),
}

export async function fetchStaticPageBySlug(
  slug: string,
  shipperId: string,
  useDynamicLanguage = false
): Promise<IStaticPage | null> {
  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL
  if (!baseUrl || !shipperId) return null

  try {
    const response = await fetch(
      `${baseUrl}${buildApiUrl('static-page', useDynamicLanguage, slug)}`,
      {
        headers: { Shipper: shipperId },
        next: { revalidate: 300 },
      }
    )

    if (!response.ok) return null

    const json = await response.json()
    return (json?.data ?? json?.static_page ?? json) as IStaticPage
  } catch {
    return null
  }
}

export default staticPageService
